module.exports = __webpack_public_path__ + "media/notice.bd7ad3d5.mp3";